<template>
  <div class="row">
    <div class="col-md-12">
      <h6 class="upper-text">Período de validação da prescrição</h6>
    </div>
    <div class="col-md-6">
      <label>DATA DE INÍCIO</label>
      <input
        disabled
        :value="formatDateToUs(start_date)"
        type="date"
        class="form-control"
      />
    </div>
    <div class="col-md-6">
      <label>DATA DE TÉRMINO</label>
      <input
        disabled
        :value="formatDateToUs(end_date)"
        type="date"
        class="form-control"
      />
    </div>
    <div class="col-md-12">
      <ErrorsMessages :errors="errors" />
      <div v-if="warnings.length > 0">
        <h6 class="text-twelve warning-alert">
          Qual(is) do(s) horário(s) deve(m) aparecer na checagem de hoje?
        </h6>
        <b-form-checkbox-group
          class="mt-3"
          v-model="times_selected"
          :options="warnings"
          stacked
        />
      </div>
      <hr v-if="warnings.length > 0" />
      <b-form-checkbox v-if="warnings.length > 0" v-model="confirm_to_finish">
        Já selecionei o(s) horário(s) para finalizar!
      </b-form-checkbox>
    </div>
    <div class="col-md-12 check-text-right">
      <confirmation-dialog
        certificate
        headerClass="modal-header-ok"
        message-title="CONFIRMAÇÃO"
        message-body="Deseja realmente finalizar o aprazamento?"
        open-class="btn-notcertified"
        open-left-icon="fa-check"
        open-text="FINALIZAR MANUAL COM ASSINATURA ELETRÔNICA"
        :loading="loading"
        :disabled="loading"
        @yes="verifyTimes"
      />
    </div>
  </div>
</template>

<script>
import ErrorsMessages from "../../../templates/Components/ErrorsMessages";

import ConfirmationDialog from "../../../templates/Components/ConfirmationDialog";

import api from "../../../services/api";

import toast from "../../../lib/ToastNotification";

import { formatDateToUs } from "../../../lib/format";

import BRyHUB from "../../../lib/BRy/hub";

export default {
  name: "Schedule",

  components: {
    ErrorsMessages,
    ConfirmationDialog,
  },

  props: {
    schedule: Object,
  },

  data() {
    return {
      confirm_to_finish: false,
      id: this.schedule.id,
      params: this.schedule.params,
      start_date: this.schedule.start_date,
      end_date: this.schedule.end_date,

      times_selected: [],

      loading: false,

      warnings: [],
      errors: [],
    };
  },

  methods: {
    formatDateToUs,

    async verifyTimes() {
      try {
        this.loading = true;

        let { params, confirm_to_finish } = this;

        const response = await api.put("/rest-home/schedule-verify-times", {
          ...params,
          confirm_to_finish,
        });

        const { error, errors, warning, warnings } = response.data;

        if (error) {
          this.errors = errors;
        }

        if (warning) {
          this.warnings = warnings;
        }

        if (!error && !warning) {
          this.finish();
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async finish() {
      try {
        this.loading = true;

        let { params, times_selected } = this;

        const response = await api.put("/rest-home/schedule", {
          ...params,
          times_selected,
        });

        const { error, errors, message } = response.data;

        if (!error) {
          toast(message, "success");
          this.$emit("finish");
          this.errors = [];

          await BRyHUB.authorize({
            id: params.id,
            table: "group_prescription_medicine",
          });
        } else {
          this.errors = errors;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
